import { ReactNode } from "react";
import { AptosWalletAdapterProvider } from "@aptos-labs/wallet-adapter-react";
import { getBkfcAptos } from "../bkfc/aptos";
import { BKFC_NETWORK, isBkfcConfigured } from "../bkfc/config";

// Aptos wallet provider for the BKFC flow ONLY. BKFC runs on Aptos while every
// other flow in this app is EVM (thirdweb/wagmi) — this provider is mounted as
// a parent layout route around the /claim/bkfc and /rewards/bkfc* routes
// (mirroring NobodySausageGlyphProvider) and must never be hoisted app-wide.
//
// The transaction submitter is the same Geomi gas-station instance the direct
// aptos client uses, so wallet-adapter writes and aptos.* reads share one
// sponsorship wiring and buyers claim with zero APT.
export function BkfcAptosProvider({ children }: { children: ReactNode }) {
  // The provider must always mount — the BKFC pages call useWallet()
  // unconditionally. Without the Geomi key / module address it simply runs
  // without the gas-station submitter (claims are disabled server-side too).
  // autoConnect: the adapter remembers the last connected wallet
  // (localStorage "AptosWalletName", cleared on disconnect) and silently
  // restores the session on mount, so a page refresh doesn't lose the
  // connection. Scoped to BKFC routes only — this provider never mounts
  // elsewhere, so no other flow sees an auto-connect attempt.
  return (
    <AptosWalletAdapterProvider
      autoConnect={true}
      dappConfig={
        isBkfcConfigured()
          ? {
              network: BKFC_NETWORK,
              transactionSubmitter: getBkfcAptos().config.getTransactionSubmitter(),
            }
          : { network: BKFC_NETWORK }
      }
      // the only way to see failures that happen entirely inside a wallet
      // extension — every wallet-adapter-react hook catches its own errors
      // and routes them here
      onError={(error: unknown) =>
        console.error("BKFC wallet adapter error:", error)
      }
    >
      {children}
    </AptosWalletAdapterProvider>
  );
}
